export enum EDataManagementSemanticTypes {
  defaultMetric = 'urn:opengov:types/semantic/datamanagement/default-metric',
  extendedSchema = 'urn:opengov:types/semantic/datamanagement/extended-schema'
}

/**
 * Numeric measure semantic types, in the URN vocabulary the pivot response uses.
 *
 * Monetary amounts are deliberately not here: they use the schema.org vocabulary and already have a
 * shared home in `SemanticTypes.StructuredDataType` from `@opengov/ogql-types`, which carries both the
 * `http` and `https` spellings that appear in real data.
 *
 * Match these exactly rather than by substring — a lowercased `includes('percentage')` test would be
 * one typo away from matching nothing, which is how monetary formatting was silently lost on screen.
 */
export enum ENumericSemanticTypes {
  percentage = 'urn:opengov:types/semantic/numeric/percentage'
}

export enum ECalendarSemanticTypes {
  FISCAL_YEAR = 'urn:opengov:types/semantic/calendar/fiscal/year',
  FISCAL_PERIOD = 'urn:opengov:types/semantic/calendar/fiscal/period',
  FISCAL_YEAR_PERIOD = 'urn:opengov:types/semantic/calendar/fiscal/year+period'
}
